import { Link, NavLink } from 'react-router-dom';
import { Award, LogIn, LogOut, ShieldCheck } from 'lucide-react';
import { useQuery } from '@tanstack/react-query';
import { cn } from '@/lib/utils';
import { getCurrentUser, isAdmin } from '@/lib/auth';

const navItems = [
  { to: '/', label: 'Submit' },
  { to: '/learn', label: 'Learn' },
  { to: '/about', label: 'About' },
  { to: '/mcp', label: 'MCP' },
  { to: '/terms', label: 'Terms' },
];

export function Header() {
  const user = useQuery({ queryKey: ['me'], queryFn: getCurrentUser, staleTime: 5 * 60_000 });
  const admin = isAdmin(user.data ?? null);

  return (
    <header className="border-b border-[var(--color-border)]">
      <div className="mx-auto flex max-w-5xl items-center justify-between px-6 py-4">
        <Link to="/" className="flex items-center gap-2 text-xl font-semibold">
          <Award className="h-6 w-6 text-[var(--color-primary)]" />
          Heuristic Hero
        </Link>
        <nav className="flex items-center gap-1 text-sm">
          {navItems.map((item) => (
            <NavLink
              key={item.to}
              to={item.to}
              end={item.to === '/'}
              className={({ isActive }) =>
                cn(
                  'rounded-md px-3 py-1.5 transition-colors',
                  isActive
                    ? 'bg-[var(--color-accent)] text-[var(--color-accent-foreground)]'
                    : 'text-[var(--color-muted-foreground)] hover:text-[var(--color-foreground)]',
                )
              }
            >
              {item.label}
            </NavLink>
          ))}
          {admin && (
            <NavLink
              to="/admin"
              className={({ isActive }) =>
                cn(
                  'flex items-center gap-1 rounded-md px-3 py-1.5 transition-colors',
                  isActive
                    ? 'bg-[var(--color-accent)] text-[var(--color-accent-foreground)]'
                    : 'text-[var(--color-primary)] hover:opacity-90',
                )
              }
            >
              <ShieldCheck className="h-4 w-4" /> Admin
            </NavLink>
          )}

          <span className="mx-1 h-5 w-px bg-[var(--color-border)]" aria-hidden />

          {user.data ? (
            <div className="flex items-center gap-2">
              <span
                className="hidden text-xs text-[var(--color-muted-foreground)] sm:inline"
                title={user.data.userDetails}
              >
                signed in as{' '}
                <span className="font-mono text-[var(--color-foreground)]">
                  {user.data.userDetails.split('@')[0]}
                </span>
              </span>
              <a
                href="/logout"
                className="flex items-center gap-1 rounded-md px-3 py-1.5 text-[var(--color-muted-foreground)] transition-colors hover:text-[var(--color-foreground)]"
              >
                <LogOut className="h-4 w-4" /> Sign out
              </a>
            </div>
          ) : (
            <a
              href="/login"
              className="flex items-center gap-1 rounded-md px-3 py-1.5 text-[var(--color-muted-foreground)] transition-colors hover:text-[var(--color-foreground)]"
            >
              <LogIn className="h-4 w-4" /> Sign in
            </a>
          )}
        </nav>
      </div>
    </header>
  );
}
